<div class="modal-header">
  <h4 class="modal-title">Thay đổi thông tin</h4>
</div>
<div class="modal-body">
  <div class="d-flex flex-column">
    <div class="row" *ngFor="let property of properties">
      <div class="col-4">
        <span>{{property.title}}</span>
      </div>
      <div class="col-4">
        <span>{{property.initValue  || '-'}}</span>
      </div>
      <div class="col-4">
        <span>{{property.changeValue}}</span>
      </div>
    </div>
    <div class="text-center" *ngIf="properties?.length === 0">
      <h5>Không có sự thay đổi</h5>
    </div>
  </div>
</div>